export const LANGUAGE_NAMES = [
  { code: 'en', native: 'English' },
  { code: 'zh', native: '中文' },
  { code: 'hi', native: 'हिन्दी' },
  { code: 'es', native: 'Español' },
  { code: 'fr', native: 'Français' },
  { code: 'ar', native: 'العربية' },
  { code: 'bn', native: 'বাংলা' },
  { code: 'pt', native: 'Português' },
  { code: 'ru', native: 'Русский' },
  { code: 'ja', native: '日本語' },
];

export const SUPPORTED_LANGUAGES = LANGUAGE_NAMES.map((l) => l.code);
export const DEFAULT_LANGUAGE = 'en';
export const RTL_LANGUAGES = ['ar'];

/**
 * Extract a valid language code from a URL pathname.
 * Returns the 2-letter code if the first segment is a supported language,
 * or null otherwise.
 *
 *   getLangFromPath('/es/pricing')  → 'es'
 *   getLangFromPath('/pricing')     → null
 *   getLangFromPath('/en')          → 'en'
 */
export function getLangFromPath(pathname) {
  const match = pathname.match(/^\/([a-z]{2})(\/|$)/);
  if (match && SUPPORTED_LANGUAGES.includes(match[1])) return match[1];
  return null;
}
